var cart=true;
var showInstalmentOrdersRequiringActionsForNextAction=false;
var previousPaymentOperator=false;
var warrantyConflictModalClosedfromButton = false;

function fancyErrorLink(){
	$('a.errorLink, a.error-link').data('type', $("#pageType").val());
}
function checkWarrantyUA(){
	if(window.sessionStorage.getItem('sdfghytu') != "1"){
		$('.cart-warranty-box').each(function(){
			window.sessionStorage.setItem('sdfghytu', "1");
			var $button = $(this).find('.js-select-warranty.selected').first();
			if($button.length && $button.data('id')>3){
				app.logEvent({
					"id": "Przedluz gwarancje K1",
					"f03": "Przedluz Gwarancje® wariant " + $button.find('.name').text(),
					"f04": $button.data('type') == 'ONE_TIME' ? 'Płatność jednorazowa' : 'Płatność miesięczna',
					"f05": $(this).data('plu')
				});
			}
		});
	}
}

function changeOperatorSource(source, element) {
	$('.sources .active').removeClass('active');
	$(element).addClass('active');
	$('.operator_source_form').each(function () {
		$(this).val(source);
	});
}

function sendK4HoursShopEvent(deliveryType) {
	var $li = $('.timeDeliveryList ul.group li');
	var $active = $li.find('input:checked').closest('li');
	if ($active.length) {
		var data = {
			id: 'k4_przedziały_czasowe',
			f03: document.location.href,
			f04: textData($active),	// wybrany pprzedział
			f05: deliveryType,
			f06: "0",
			f07: "0",
			f08: "0",
			f09: "0",
			f10: "0",
			f11: "0",
			f12: "0",
			f13: "0",
			f14: "0"
			
		}
		function textData($element) {
			let n = $element.find('.name').text();
			if (n && n.length) {
				let p = $element.find('.price').text();
				return n + ' / ' + ($element.is('.notActive') ? 'niedostępny' : 'dostępny') + ' / ' + (p.length ? p : '0');
			} else { 
				return false;
			}
		}
		$li.each(function (i, element) {
			var index = 'f' + (i + 6);
			if (i < 9) { 
				if (index.length == 2) {
					index = index.substr(0, 1) + '0' + index.substr(1, 1);
				}
				let text = textData($(element));
				if (text) {
					data[index] = text;
				}
			}
		});
		if (data.f04) {
			app.logEvent(data);
		}
	}
}
function sendK4DayShopEvent(deliveryType) {
	var $li = $('.delivery-day-list li');
	var $active = $li.find('input:checked').closest('li');
	if ($active.length) {
		var data = {
			id: 'k4_data_dostawy',
			f03: document.location.href,
			f04: textData($active),
			f05: deliveryType,
			f06: "0",
			f07: "0",
			f08: "0",
			f09: "0",
			f10: "0",
			f11: "0",
			f12: "0"
		}
		function textData($element) {
			let d = $element.find('.deliveryDayDate').val();
			if (d && d.length) {
				d = d.split('-');
				let p = $element.find('.deliveryName span');
				return d[2] + '.' + d[1] + ' / ' + ($element.is('.notActive') ? 'niedostępny' : 'dostępny') + ' / ' + (p.length ? p.text() : '0');
			} else {
				return false;
			}
		}
		$li.each(function (i, element) {
	
			var index = 'f' + (i + 6);
			if (i < 7) {
				if (index.length == 2) {
					index = index.substr(0, 1) + '0' + index.substr(1, 1);
				}
				let text = textData($(element));
				if (text) {
					data[index] = text;
				}
			}
		});
		if (data.f04) {
			app.logEvent(data);
		}
	}
}

function showModalAddressError(data, callback){

	var message = data.message;
	var isAnyProductESD = data.isAnyProductElectronicSoftwareDistribution === true;
	var isAddressValid = data.isAddressValid === true;
	var isInvoiceAddressValid = data.isInvoiceAddressValid === true;
	var isDeliveryAddressValid = data.isDeliveryAddressValid === true;

	var buttons = [
		{
			text: "Popraw dane",
			cssClass: "btn-second",
			click:function(){
				app.closeModal();
				scrollToAddressValidate(isAddressValid, isDeliveryAddressValid, isInvoiceAddressValid);
			}
		},{
			text: "Pomiń",
			cssClass: "btn-fourth",
			click:function(){
				app.closeModal();
				callback();
			}
		}
	];

	if(isAnyProductESD) {
		buttons = [
			{
				text:"Edytuj",
				cssClass: "btn-second",
				click:function(){
					app.closeModal();
					scrollToAddressValidate(isAddressValid, isDeliveryAddressValid, isInvoiceAddressValid);
				}
			}
		]
	}
	loadingStop();
	app.showModal({
		id:'adress-validate-modal',
		content: data.message,
		buttons: buttons
	});
}

function showModalBlockPayment(data){
	loadingStop();
	app.showModal({
		id:'adress-validate-modal',
		content: data.message,
		buttons: [{
			text: 'OK',
			cssClass: 'btn-primary',
			click:function(){
				app.closeModal();
			}
		}]
	});
}

function scrollToAddressValidate(isAddressValid, isDeliveryAddressValid, isInvoiceAddressValid){

	if(!isInvoiceAddressValid){
	}else{
	}

	if(!isAddressValid){

	}else if(!isDeliveryAddressValid){

	}else if(!isInvoiceAddressValid){
	}
}

$( document ).ready(function() {

	if($('.split-payment-message').length) {
		$.fancybox($('.split-payment-message').html(), {
			autoDimensions:	true,
			padding: 10
		});
	}

});

function createRequestData() {
	const warrantyId = $(this).find('input[name^=warranty-id]').filter(':checked').val();
	warrantyConflictModalClosedfromButton = true;
	UA.interaction('PG ABO na Raty','Kliknięcie', warrantyId == '' ? 'Rezygnacja z PG' : 'Proponowany PG');

	if (!warrantyId) return;

	const productId = $(this).find('input[name^=product-id]').val();
	const suiteCode = $(this).find('input[name^=suite-code]').val();

	return {
		productId,
		suiteCode,
		warrantyId
	};
}


function instalmentOrdersRequiring(){
	$.fancybox($('#instalmentOrdersRequiringActions').parent().html(),{
		autoDimensions:true,
		onClosed:function(){
			if(showInstalmentOrdersRequiringActionsForNextAction){
				showInstalmentOrdersRequiringActionsForNextAction=false;
				zamawiam();
			}
		}
	});
}

function goToEcardAlert(time, messageId){
	window.time=time;
	var opt={
		hideOnOverlayClick:false,
		showCloseButton:false,
		enableEscapeButton:false,
		autoDimensions:true,
		onComplete:function(){
			goToEcardCount(window.time);
		}
	};

	$.fancybox({
		href: messageId
	},opt);
}

function showLayerMessage(messageId){
	var opt={
			autoDimensions:true
	};
	$.fancybox($(messageId).html(),opt);
}

function goToEcardCount(time){
	time--;
	window.time=time;
	var t=time+' ';
	if(time==1)t+='sekundę';
	else if(time%10>1 && time%10<5)t+='sekundy';
	else t+='sekund';
	$('#fancybox-content #eCardCount').length > 0 ? $('#fancybox-content #eCardCount').html(t) : $('#fancybox-content #eCardCountNumber').html('('+time+')');
	if(time>0){
		setTimeout("goToEcardCount(time)",1000);
	}
	if(time==0){
		if($('#fancybox-content .place').length){
			$('#fancybox-content .place')[0].click();
		}
	}
}
function addToCardAccessories(id, name){
	if(pageType=='cart'){
		addPromotedProduct(id);
	}else if(pageType=='precart'){
		addToCard(id,name,'TO_CART');
		$('#acc'+id).prop('checked',true);
	}
}

function tradeDoublerConfirm(orderNumber){
	var url = '/order-path-trade-doubler-confirm.ltr?orderNumber='+orderNumber;
	$.ajax({
	   type: "GET",
	   url: url
	 });

}

function fancyRegulamin(){
	$('#regulamin').fancybox({
		width: 1000,
		height: 480,
		type:'iframe'
	});
}

function checkZipCode( $input ) {
	return $input.length && /\d{2}-\d{3}/.test( $input.val() );
}

var hideTimer = null;
var loadOption=[];
var hideDelay =200;
var startDelay=500;
moveContainerId='';

function kalkulatorCreditAgricoleEvents(obj){
	//nadpisywane przez Euro
}

function logReg(i) {}

function noBayServices(){
	if($('#no_service:checked').length)$('.warrantyBox input:checked').not('#no_service').attr('checked',false);
}

function setValue(fieldId, fieldValue){
	$('#'+fieldId).val(fieldValue);
}

function scrollToError(){
	var t=$('label.error:visible, span.error:visible').not('.valid');
	/*t.each(function(){
		try{console.log('błąd: '+$(this).attr('htmlfor'));}catch(e){}
	});*/
	var parent = t.closest('.errorBox');
	if (!parent.length) {
		parent = t.closest('.validate-target');
	}
	console.log(parent)
	if(parent.length)$.scrollTo(parent, 800);
}

function changePassStart(){
	$('#passForm').validate({
		rules:{
			"passwordOld": {
				required:true
			},
			"passwordNew": {
				required:true,
				minlength: 5
			},
			"passwordNewRepeat": {
				required:true,
				minlength: 5,
				equalTo: "#passwordNew"
			}
		},
		messages:{
			"passwordOld": {
				required:"Podaj stare hasło"
			},
			"passwordNew": {
				required:"Podaj nowe hasło",
				minlength: "Hasło jest za krótkie (5 znaków)"
			},
			"passwordNewRepeat": {
				required:"Powtórz nowe hasło",
				minlength: "Hasło jest za krótkie (5 znaków)",
				equalTo: "Nowe hasła nie są identyczne"
			}
		}
	});
}

function roundEuro(i){
	var tmp=Math.floor(i*1000);
	var mod=tmp%10;
	if(mod==0){
		i=Math.ceil(i*100)/100;
	}else if(mod<6){
		i=Math.floor(i*100)/100;
	}else {
		i=Math.ceil(i*100)/100;
	}
	return i;
}
function price(i){
	i=roundEuro(i)+'';
	i=i.replace('.',',');
	if(i.indexOf(',') == i.length-2 && i.indexOf(',')>-1)i+='0';
	i+=' zł';
	return i;
}

//funkcje nadpisywane i wykorzystywane do zdarzeń analitycznych
function _orderDeliveryTimeIntervalsEvents(){}

function retriveCart() {

	$.ajax({
		type: "POST",
		url:'/cart.ltr',
		data: {
			c : $("#cookieToRetrieve").val()
		},
		cache:false,
		success:function(html){
			document.location.href='/cart.bhtml';
		},error:function(){
			fancyOk('Wystąpił błąd.');
		}
	});
}

function zarejestruj(){
	if ($('#registerForm').valid()) {
		emailInvalid.check(function () {
			loadingStart();
			refreshCsrfTokenAndSubmit($('#registerForm'));
		});
	}
}
function zaloguj(){
	if($('#loginForm').valid()){
		loadingStart();
		refreshCsrfTokenAndSubmit($('#loginForm'));
	}
}

function refreshCsrfTokenAndSubmit($form, count=0) {
	function redirectToTargetUrl(url) {
		if(url.startsWith("/") || url.startsWith("http")) {
			loadingStart();
			if(url.indexOf("/simple-login.ltr?login_") == 0) {
				setTimeout(function(){
					$.fancybox({href:url},{
						autoDimensions:	true,
						onComplete:function(){
							fastOrderLoginView();
						}
					});
				},500);
			}else if (url.indexOf("j_spring_security_check")!==-1) {
				$.post({
					url: url,
					success: redirectToTargetUrl
				});
			} else {
				window.location.href = url;
			}
		} else {
			window.location.reload();
		}
	};
	function error403(count){
		$.ajax({
			url: '/refreshCsrf.ltr',
			type: 'GET',
			success: function(newToken) {
				//$form.find("input[name=_csrf]").val(newToken);
				$("meta[name='_csrf']").attr("content",newToken);
				refreshCsrfTokenAndSubmit($form, count);
			}
		});
	}

	$form.find("input[name=_csrf]").remove();
	$form.trigger('agreementSubmit');
	$form.ajaxSubmit({
		success: redirectToTargetUrl,
		statusCode: {
			403: function() {
				count++;
				if(count>2){
					app.alert('Nieudana próby wysłania formularza. Możliwe problemy z obsługą ciasteczek lub blokowaniem treści.');
					return;
				}else{
					error403(count);
				}
			},
			500:function(){
				loadingStop();
				app.alert('Nieudana próba wysłania formularza. Spróbuj ponownie później.')
			}
		}
	});
}

function sendOperatorSource(element) {
	loadingStart();
	var source = $('.operator_source_form').val();
	$.ajax({
		type: "POST",
		url: '/add-source-param.ltr',
		data: {
			operator_source : source,
			from : $('#from').val()
		},
		success: function(result) {
			if(result == 'ok') {
				$('#operator_source_error').addClass("none");
				//jeśli znaleziono klienta który dokonał już zakupu - wypełniany i wysyłany jest formularz "klient zna swój login"
				if($(element).hasClass('previous-client')) {
					$('#frontForm').submit();
				} else {
					$(element).closest('form').submit();
				}
			}
			else {
				loadingStop();
				$('#operator_source_error').removeClass("none");
			}
		},
		error: function() {
			loadingStop();
			$('#operator_source_error').removeClass("none");
		}
	});
}

function summaryStart() {

	$('tr.prod:odd').addClass('odd');
	$('tr.prod').each(function(){
		$(this).prev().children('td').addClass('pB10');
	});
	$('.cart_summarize tr:last td').addClass('pB10');
	$('.cart_summarize tr.small').each(function(){
		if(!($(this).next().hasClass('small')))$(this).children('.list').addClass('lastlist');
	});
	$('.js-trade-doubler').on('load', function() {
		tradeDoublerConfirm($(this).data('order-number'));
	});
}

function checkVoucherOrNextAction() {
	formAction('NEXT');
}

function isFrontFormValid() {
	let $form = $('#frontForm');
	let isFormValid = true;

	// giftCardOrder
	if (!$form.length) {
		$form = $('#gift-card-order-form');
		$form.submit();
		isFormValid = false;
	}

	if (!$form.valid()) {
		scrollToError();
		isFormValid = false;
	}

	if($('input.payment-type').length && !$('input.payment-type:checked').length){
		$('.order-navigation').addClass('error error-payment');
		isFormValid = false;
	}

	return isFormValid;
}

function updateWarrantyQuestionnaire(){
	var status = true;
	var $invalidQuestions = [];
	var $productList = $('#cart .cart_summarize .cart-warranty-box');
	var $selectedWarranties = $productList.find('.payment-warranties .js-select-warranty.selected:not([data-id="0"])');
	var data = [];
	if($selectedWarranties.length != 0) {
		$productList.each(function(){
			var mainCartItemId = $(this).data('cart');
			var warrantyQuestions = $(this).find('.warranty-question');
			if(warrantyQuestions.length != 0){
				warrantyQuestions.each(function(){
					var $checkedAnswer = $(this).find('input[type=radio]:checked');
					if ($checkedAnswer.length != 0 && mainCartItemId) {
						data.push({
							mainCartItemId: mainCartItemId,
							answerNumber: $checkedAnswer.attr('name').slice($checkedAnswer.attr('name').length - 1)*1,
							answerValue: $checkedAnswer.val()
						});
					}else{
						if($(this).closest('.cart-warranty-box').find('.js-select-warranty.selected:not([data-id="0"])').length != 0){
							$invalidQuestions.push($(this).addClass('error'));
						}
					}
				});
			}
		});
		if($invalidQuestions.length != 0){
			$.scrollTo($invalidQuestions[0].closest('.warranties-questionnaire'));
			app.alert('Uzupełnij odpowiedzi na pytania w ankiecie.');
			return false;
		}

		loadingStart();
		$.ajax({
			url:'/cart-update-warranty-questionnaire.ltr',
			type: 'POST',
			async: false,
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success:function(json){
				loadingStop();
				if(json.status == 'SUCCESS') {
					console.log('warranties saved');
					status=true;
				}else{
					app.alert(json.messages[0]);
					status=false;
				}
			},
			error:function(){
				loadingStop();
				console.log('Nieudana próba wysłania ankiet.');
				status=false;
			}
		});
	}
	return status;
}

function regon({ $box, $nip, $companyName, $country, $city, $street, $houseNumber, $flatNumber, $zipCode }) {
	function nipValidator(nip) {
		var verificator_nip = new Array(6, 5, 7, 2, 3, 4, 5, 6, 7);
		var n = 0;
		var ile;
		for (var i = 0; i < 9; i++) {
			ile = nip.charAt(i) / 1 * verificator_nip[i] / 1;
			n += ile;
		}
		// walidacja odrzuca nip z samymi zerami
		if (n === 0) {
			return false;
		}
		// czy wszystkie cyfry są takie same
		const allDigitsSame = nip.split('').every(digit => digit === nip[0]);
		if (allDigitsSame) {
			return false;
		}
		n %= 11;
		if (n != nip.charAt(9)) {
			return false;
		} else {
			return true;
		}
	}

	
	var savedNip;
	var savedData = {};
	if ($box.length && $nip.length) {
		savedNip = $nip.val();
		function check() {
			var nip = $nip.val().replace(/[\ _\-]/gi, "");
			//if (nip != savedNip) {
			if (nip.length == 10) {
				if (nipValidator(nip)) {
					savedNip = nip;
					return true;
				};
			}
			// }
			return false;
		}
		
		function hide() {
			$box.removeClass('show done');
		}
		function show() {
			$box.addClass('show').removeClass('done');
		}
		function done(json) {
			var $form = $nip.closest('form');
			if ($form.length) {
				if ($companyName.length) {
					if ($companyName.is('input')) {
						$companyName.val(json.companyName).trigger('input');
					} else {// contenteditable
						$companyName.text(json.companyName).trigger('input');
						$form.validate().element($companyName.next());
					}
				}
				if ($city.length) {
					$city.val(json.city);
					$form.validate().element($city);
				}
				if ($street.length) {
					$street.val(json.street);
					$form.validate().element($street);
				}
				if ($houseNumber.length) {
					$houseNumber.val(json.houseNumber);
					$form.validate().element($houseNumber);
				}
				if ($flatNumber.length) {
					$flatNumber.val(json.flatNumber);
					$form.validate().element($flatNumber);
				}
				if ($zipCode.length) {
					$zipCode.val(json.zipCode);
					$form.validate().element($zipCode);
				}
				if ($country.length) {
					$country.val('PL').trigger('change');
				}
			}
			$box.addClass('done');
		}

		function change($input, name) {
			if ($input.val() != savedData[name]) {
				$box.removeClass('done');
			}
		}
		function showError() { 
			app.showModal({
				id: 'regon-loading-error',
				header: 'Rejestr REGON jest niedostępny',
				content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP. Prosimy spróbuj za chwilę lub wprowadź dane ręcznie.',
				buttons: [{
					text: 'Rozumiem',
					click: function () {
						app.closeModal();
					}
				}]
			});
		}

		function load() {
			app.showModal({
			    id: 'regon-loading',
			    close: false,
			    content: '<div>Pobieramy dane firmy.<br/>Może to zająć chwilę</div>',
			    callbackOpen: function () { 
					$.ajax({
						url: '/company-details.ltr?nip=' + savedNip,
						success: function (json) {
							if (json.status === 'SUCCESS') {
								setTimeout(function () {			// czasowo, modal się nie zamykał
									app.closeModal();
									savedData = json;
									done(json);
								}, 400);
							} else if (json.status === 'NOT_FOUND') {
								app.showModal({
									id: 'regon-loading-error',
									header: 'Brak danych w rejestrze REGON',
									content: 'Nie udało się pobrać danych na podstawie podanego przez Ciebie numeru NIP. Prosimy wprowadź dane ręcznie.',
									buttons: [{
										text: 'Rozumiem',
										click: function () {
											app.closeModal();
										}
									}]
								});
							} else {
								showError();
							}
						}, error: function () { 
							showError();
						}
					});
			    }
			});
		}
		$('.js-search-regon', $box).on('click', function () {
			load();
		});
		$nip.on('input', function () {
			if (check()) {
				show();
			} else {
				hide();
			}
		});
		$companyName.on('input', function () {
			if ($companyName.text() != savedData['companyName']) {
				$box.removeClass('done');
			}
		});
		$city.on('input', function () {
			change($city, 'city');
		});
		$street.on('input', function () {
			change($street, 'street');
		});
		$houseNumber.on('input', function () {
			change($houseNumber, 'houseNumber');
		})
		$flatNumber.on('input', function () {
			change($flatNumber, 'flatNumber');
		});
		$zipCode.on('input', function () {
			change($zipCode, 'zipCode');
		});
	}
}
